import { map } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthorizationService } from '../../shared/authorization.service';
import { KeyValue } from '../../shared/key-value';

@Component({
  selector: 'reset-password',
  templateUrl: 'reset-password.component.html'
})
export class ResetPasswordComponent implements OnInit {
  user: any = {};
  errorMsg: string = '';
  currentYearCopyRight: number = new Date().getFullYear();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public authService: AuthorizationService
  ) {}

  ngOnInit() {
    // Extract token from URL
    this.route.queryParams.subscribe(params => {
      this.user.token = params['token'];
      if (this.user.token) {
        this.fetchUserDetails();
      } else {
        this.errorMsg = 'Invalid or missing token';
      }
    });
  }

  fetchUserDetails() {
    this.authService.get(`${KeyValue.api_fetch_user_from_token}`, { params: { token: this.user.token } })
      .pipe(map(res => res))
      .subscribe(
        data => {
          if (data.error) {
            if(data.email){
              this.user.email = data.email;
            }
            const forgotPasswordLink = '<a href="/forgot-password">Click here to Reset Password</a>';
            this.errorMsg = data.error === 'Token expired' 
              ? `Your reset link has been expired. Please request a new one. ${forgotPasswordLink}`
              : `Invalid token. Please request a new reset link. ${forgotPasswordLink}`;
          } else {
            this.user.email = data.email;
          }
        },
        error => {
          this.errorMsg = 'Failed to retrieve user details. Please try again.';
        }
      );
  }

  revealPassword(id: string, image_id: string) {
    const element = document.getElementById(id) as HTMLInputElement;
    const imageElement = document.getElementById(image_id) as HTMLImageElement;
    if (element.type === 'password') {
      element.type = 'text';
      imageElement.src = 'assets/images/eye.svg';
    } else {
      element.type = 'password';
      imageElement.src = 'assets/images/eye_password.svg';
    }
  }

  resetPassword(userForm: any) {
    this.errorMsg = '';
    if (!this.user.newPassword || !this.user.confPassword) {
        this.errorMsg = "Please ensure every field is properly filled.";
        return;
    }
    if (this.user.newPassword !== this.user.confPassword) {
        this.errorMsg = "Passwords must match. Please check and re-enter.";
        return;
    }
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,}$/;
    if (!passwordRegex.test(this.user.newPassword)) {
        this.errorMsg = "Password does not meet the required policy."
        return;
    }
    if (userForm.valid) {
        this.submit_reset_password();
    }
  }

  submit_reset_password() {
    this.authService.post(KeyValue.api_reset_password_using_token, { member_details: this.user })
      .pipe(map(res => res)).subscribe(
        data => {
          if (data.status == 200) {
            localStorage.setItem('resetPasswordSuccessMessage', 'Password reset successful. You can now log in.');
            this.router.navigate(['/sign-in']);
          }
          else {
            const forgotPasswordLink = '<a href="/forgot-password">Click here to Reset Password</a>';
            this.errorMsg = data.errors + `. ${forgotPasswordLink}`;
          }
        },
        error => {
          console.log('Error: ', error);
          KeyValue.flash_msg_update({ msg: 'An error occurred while resetting the password.', type: 'error_messages' });
        }
      );
  }

}
